import * as Isotope from "../../libs/isotope/isotope.pkgd.min";

/**
 * Класс для того чтоб делать обычный masonry грид с тегами для фильтрации
 * */
export default class nonAjaxGrid {
  constructor(options) {
    const defaults = {
      grid_wrapper : '.na-js-grid', //общий контейнер грида
      grid : '.na-js-grid-content', //прямой контейнер для грида, в котором лежат grid-item
      tags: '.na-js-tag', //тег, в котором должен быть data-filter
      tags_wrap: '.na-js-tag-list', //группа тегов
      item: '.grid-item', //элемент грида
      filter_part: 'term_product_'//часть, которая приставляется к классу для фильтрации (для большей уникальности)
    }

    this.options = Object.assign(defaults, options);
    this.grid = $(this.options.grid)
    this.parentCategory = $('.js-configurator-page-filters-accordion-title').eq(0).data('category')

    this.make(this.options.grid)
    this.tagInit()
  }

  make(grid) {

    this.iso = new Isotope(grid, {
      transitionDuration: 0,
      masonry: {
        columnWidth: this.options.item,
        gutter: this.options.gutter
      }
    });
  }

  tagInit() {
    let tags = $(this.options.tags)
    let object = this;
    
    $('.js-configurator-page-filters-accordion').on('click', '.js-configurator-page-filters-accordion-title', function () {
      
      object.grid.find('.search-no-results').css('display', 'none');
      object.parentCategory = $(this).data('category')
      
      let filter = '.' + object.options.filter_part + object.parentCategory
  
      filter = object.getFilter(filter, object)
      
      object.iso.arrange({
        filter: filter
      })
    })

    tags.on('click', function () {
      let filter = '.' + object.options.filter_part + object.parentCategory
      
      object.grid.find('.search-no-results').css('display', 'none');

      filter = object.getFilter(filter, object)
      
      object.iso.arrange({
        filter: filter
      })
    })
  }
  
  getFilter(filter, object) {
    /*Ищем группы фильтров и в них ищем отмеченные элементы.*/
    /*Из data элементов берем значение.*/
    $('.js-configurator-page-filters-accordion.active').find(object.options.tags_wrap).each(function () {
      let ths_parent = $(this)
    
      ths_parent.find('.is-checked').each(function () {
        let ths_child = $(this)
        let data_filter = ths_child.data('filter');
      
        if(data_filter !== '' && !ths_child.hasClass('js-exclude-filter')) {
          filter += '.' + object.options.filter_part + data_filter
        }
        else if (ths_child.hasClass('js-exclude-filter')) {
          filter += ':not(.' + object.options.filter_part + data_filter + ')'
        }
      })
    })
  
    if($(filter).length === 0) {
      object.grid.find('.search-no-results').css('display', 'block');
    }
    
    return filter
  }
}